export default "__VITE_ASSET__24e30cd0__"